module.exports = __webpack_public_path__ + "static/media/6.67cb41c3.jpg";